module.exports = __webpack_public_path__ + "assets/images/05_0ce16b347a98af613191c69ae11ab167.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stages/stage-two/exercise-1/05.png
// module id = 230
// module chunks = 0